import React from 'react';

/**
 * کارت‌های آماری فشرده برای هدر مشاهده سرنخ/معامله
 */
const EntityMiniStatCards = ({ items = [] }) => {
  const visible = items.filter((item) => item.show !== false);
  if (!visible.length) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {visible.map((item) => (
        <div
          key={item.key}
          className={[
            'inline-flex items-center gap-2 px-2.5 py-1.5 rounded-lg border min-w-0',
            'bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm',
            item.borderClass || 'border-gray-200 dark:border-gray-700',
          ].join(' ')}
        >
          {item.icon && (
            <span
              className={[
                'w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 text-xs',
                item.iconBgClass || 'bg-gray-100 dark:bg-gray-700',
              ].join(' ')}
            >
              {item.icon}
            </span>
          )}
          <div className="min-w-0">
            <p className="text-[10px] text-gray-500 dark:text-gray-400 mb-0 leading-none custom-font">
              {item.label}
            </p>
            <p className="text-xs font-semibold text-gray-900 dark:text-white truncate custom-font leading-tight mt-0.5">
              {item.value}
            </p>
          </div>
          {item.extra}
        </div>
      ))}
    </div>
  );
};

export default EntityMiniStatCards;
